module.exports = require("core-js-pure/features/instance/bind");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/instance/bind.js
// module id = 258
// module chunks = 0 1